import { SxProps, Theme } from "@mui/material/styles";
import { HIGHLIGHT_COLORS } from "../../../constants/appColors";

/** Base outlined input styling (compact padding, small font, dark text). */
export const BASE_INPUT_SX: SxProps<Theme> = {
  ".MuiOutlinedInput-root": {
    // Standardise field height across all filter inputs.
    minHeight: 38,
    paddingTop: "2px",
    paddingBottom: "2px",
    fontSize: "0.85rem",
    fontWeight: 600,
    color: "#454545",
    width: "100%",
  },
};

/** Multi-select input/tag flex behaviour (single-line chips + count). */
export const getMultiSelectSx = (
  hasValue: boolean,
  isFocused: boolean,
): SxProps<Theme> => ({
  "& .MuiAutocomplete-input": {
    minWidth: "0 !important",
    flexGrow: hasValue && !isFocused ? 0 : 1,
    width: hasValue && !isFocused ? "1px !important" : "auto",
  },
  "& .MuiAutocomplete-inputRoot": {
    flexWrap: "nowrap",
    // Reserve room on the right for the built-in clear + dropdown icons so
    // chips/input don't overlap them.
    paddingRight: hasValue ? "60px !important" : undefined,
    paddingLeft: hasValue ? "8px !important" : undefined,
    "& .MuiAutocomplete-tag": {
      margin: "2px 4px 2px 0",
      maxWidth: "100%",
      // Compact chip height.
      height: 22,
      fontSize: "0.72rem",
      "& .MuiChip-label": {
        paddingLeft: "8px",
        paddingRight: "6px",
        // Match the default input value weight.
        fontWeight: 600,
      },
      "& .MuiChip-deleteIcon": {
        fontSize: "16px",
        marginRight: "3px",
      },
    },
  },
});



/** Global default popup min-width (so the list is wider than narrow fields). */
export const ENR_AUTOCOMPLETE_POPUP_MIN_WIDTH = 260;

/**
 * Compact option rows in the popup (MUI 5.11 uses componentsProps.paper) plus
 * a global minimum popup width.
 *
 * `popper.sx.width: fit-content` detaches the popup from the field width so the
 * `paper.minWidth` can actually widen the list beyond a narrow field.
 */
export const ENR_AUTOCOMPLETE_COMPACT_POPPER = {
  popper: {
    sx: {
      width: "fit-content !important",
    },
  },
  paper: {
    sx: {
      minWidth: ENR_AUTOCOMPLETE_POPUP_MIN_WIDTH,
      "& .MuiAutocomplete-option": {
        minHeight: "auto",
        paddingTop: "4px",
        paddingBottom: "4px",
        fontSize: "0.8rem",
      },
      "& .MuiAutocomplete-option .MuiCheckbox-root": {
        padding: "2px",
        marginRight: "6px",
      },
      // Thin, light scrollbar. The actual scroller is the listbox inside the
      // paper, so target both the paper and the listbox.
      "&, & .MuiAutocomplete-listbox": {
        scrollbarWidth: "thin",
        scrollbarColor: "rgba(0,0,0,0.15) transparent",
        "&::-webkit-scrollbar": {
          width: 6,
        },
        "&::-webkit-scrollbar-thumb": {
          borderRadius: 3,
          backgroundColor: "rgba(0,0,0,0.15)",
        },
        "&::-webkit-scrollbar-track": {
          backgroundColor: "transparent",
        },
      },
    },
  },
} as const;
